import {
    Component,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core'
import {
    ClientNotification,
    ClientNotificationCardComponent,
} from '@baboor/client-ui'

@Component({
    standalone: true,
    selector: 'app-client-notification-drawer',
    imports: [ClientNotificationCardComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-notification-drawer.component.html',
})
export class ClientNotificationDrawerComponent {
    notifications = input<ClientNotification[]>([])
    close = output<void>()
}
